import { useBondsBondFieldApi } from '../api';

export const useBondsBondSAccOblStartPrice = () => {
  const response = useBondsBondFieldApi('S_ACC.OBL_START_PRICE');
  return response;
};
